module.exports = __webpack_public_path__ + "img/youssry.f9815ecd.jpg";